
const NOUNS = [
    // Weapons / Combat
    "Blade", "Reaper", "Fang", "Claw", "Saber", "Bolt", "Lance",
    "Dagger", "Scythe", "Hammer", "Arrow", "Spear", "Axe", "Pike",
    "Maul", "Bracer", "Shiv", "Talon",
    
    // Roles / Archetypes
    "Warden", "Sentry", "Phantom", "Rogue", "Hunter", "Ranger", "Prowler",
    "Slayer", "Raider", "Nomad", "Drifter", "Outlaw", "Shade", "Specter",
    "Wraith", "Stalker", "Vance", "Warlord", "Seeker",
    
    // Nature / Elements
    "Serpent", "Wolf", "Raven", "Drake", "Viper", "Cobra", "Falcon", "Raptor",
    "Lynx", "Jackal", "Mantis", "Crow", "Hornet", "Vulture", "Asp",
    
    // Sci-fi / Cosmic
    "Pulse", "Flux", "Void", "Core", "Node", "Vector", "Rift", "Surge",
    "Comet", "Nova", "Quasar", "Nebula", "Pulsar", "Sector", "Relay",
    
    // Abstract
    "Shadow", "Echo", "Omen", "Ruin", "Forge", "Glitch", "Cipher", "Signal",
    "Static", "Vertex", "Nexus", "Apex", "Zenith", "Abyss", "Chaos",
];

const PREFIXES = [
    // Fire / Heat
    "Molten", "Ember", "Inferno", "Scorch", "Blaze", "Pyrex", "Cinder",
    "Ignite", "Pyre",
    
    // Ice / Cold
    "Frost", "Cryo", "Glacial", "Arctic", "Blizz", "Sleet",
    "Subzero", "Hail",
    
    // Dark / Shadow
    "Umbra", "Null", "Crypt", "Abysm", "Onyx", "Ebon",
    "Murk", "Dusk", "Grim",
    
    // Celestial / Space
    "Solar", "Lunar", "Orbit", "Stellar", "Astral", "Cosmic", "Galax",
    "Nebul", "Pulsar",
    
    // Electric / Storm
    "Volt", "Thunder", "Tempest", "Static", "Surge", "Cyclone", "Gale",
    "Arc", "Zap",
    
    // Speed / Force
    "Swift", "Hyper", "Blitz", "Rapid", "Velox", "Turbo", "Nitro", "Warp",
    
    // Metal / Material
    "Iron", "Steel", "Cobalt", "Titan", "Tung", "Chrome", "Iridium",
    "Adamant", "Ferric", "Alloy",
    
    // Toxic / Bio
    "Venom", "Toxic", "Noxious", "Viral", "Plague", "Blight", "Corrix",
    "Acid", "Caustic",
    
    // Mythic / Arcane
    "Runic", "Arcane", "Hex", "Eldric", "Cursed", "Primal", "Savage",
    
    // Status / Rank
    "Silent", "Hollow", "Broken", "Brutal", "Stern", "Rigid",
    "Bold", "Cruel", "Brazen",
    
    // Colour / Aesthetic
    "Crimson", "Scarlet", "Violet", "Indigo", "Azure", "Neon", "Phantom",
    "Gilded", "Pale",
    
    // Misc cool nouns as prefixes
    "Star", "Chaos", "Storm", "Death", "Blood", "Dark", "War", "Ghost",
    "Bone", "Soul", "Demon", "Dread", "Ash", "Night", "Rune",
    "Vile", "Dire", "Feral", "Mad", "Dead", "Void",
];

const SUFFIXES = [
    // Letters / Short punchy
    "X", "Z", "IX", "XL", "XV",
    
    // Numbers (cool ones only)
    "Zero", "One", "Prime", "Null",
    
    // Abstract nouns
    "Void", "Forge", "Core", "Rift", "Surge", "Flux", "Pulse", "Apex",
    "Nexus", "Zenith", "Nadir", "Vertex", "Vortex", "Abyss",
    
    // Suffixes suggesting permanence / power
    "Born", "Bound", "Bane", "Fall", "Rise", "Break", "Strike", "Breach",
    "Wreck", "Burn", "Slash", "Rend", "Crush",
    
    // Evocative single words
    "Proto", "Dogma", "Engine", "Matrix", "Vector", "Cipher",
    "Signal", "Static", "Omega", "Alpha", "Sigma",
    
    // Mythic / Arcane
    "Hex", "Rune", "Glyph", "Sigil", "Omen", "Curse",
    
    // Sci-fi flavour
    "System", "Array", "Relay", "Grid", "Sync", "Drive", "Warp",
    
    // Short punchy words
    "Crest", "Edge", "Peak", "Mark", "Brand", "Claw", "Talon",
    "Fang", "Scale", "Shard", "Spike", "Blade",
];

export default function randomName() {
    let alias;
    while(true) {
        const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
        if (Math.random() < 0.5) {
            alias = PREFIXES[Math.floor(Math.random() * PREFIXES.length)] + noun;
        } else {
            alias = noun + SUFFIXES[Math.floor(Math.random() * SUFFIXES.length)];
        }
        if (alias.length < 12) return alias;
    }
}
